export default __webpack_public_path__ + "static/media/TxHistoryNotAvailable.b486a140.svg";